import React, { useState, useEffect } from "react";
import LoginPage from "./LoginPage.jsx";
import SignupPage from "./SignupPage.jsx";
import InOrOut from "./InOrOut.jsx";
import HeadToHead from "./HeadToHead.jsx";
import Profile from "./Profile.jsx";
import Compare from "./Compare.jsx";
import HotTakes from "./HotTakes.jsx";

export default function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState('login');
  const [gender, setGender] = useState('neutral');
  const [themeKey, setThemeKey] = useState(0); // Force re-render when theme changes

  useEffect(() => {
    if (!user) {
      fetch('/api/me').then(r => r.json()).then(u => {
        if (u) { setUser(u); setGender(u.gender); setView('profile'); }
      });
    }

    // Listen for gender changes to update theme immediately
    const handleGenderChange = (event) => {
      if (user) {
        user.gender = event.detail.gender;
        setThemeKey(prev => prev + 1); // Force re-render
      }
    };

    window.addEventListener('userGenderChanged', handleGenderChange);
    return () => window.removeEventListener('userGenderChanged', handleGenderChange);
  }, [user]);

  // Apply the theme class to the <body> element so global styles update
  useEffect(() => {
    if (!user) return;
    
    const theme = getThemeClass();
    document.body.classList.remove('theme-boy', 'theme-girl', 'theme-neutral');
    if (theme) document.body.classList.add(theme);
  }, [themeKey, user?.gender]);

  if (!user) {
    if (view === 'signup') {
      return <SignupPage
        onLogin={u => { setUser(u); setView('profile'); }}
        onBackToLogin={() => setView('login')}
      />;
    }
    
    return <LoginPage
      onLogin={u => { setUser(u); setView('profile'); }}
      onGoToSignup={() => setView('signup')}
    />;
  }

  const navItems = [
    ['profile', '👤', 'Profile'],
    ['inorout', '💝', 'In or Out'],
    ['headtohead', '⚔️', 'Head to Head'],
    ['compare', '🤝', 'Compare'],
    ['hottakes', '💬', 'Hot Takes'],
  ];

  const logout = async () => {
    await fetch('/api/logout', { method: 'POST' });
    setUser(null);
    setView('login');
  };

  const views = {
    profile: (<Profile user={user} go={setView} logout={logout} />),
    inorout: (<InOrOut user={user} go={setView} />),
    headtohead: (<HeadToHead user={user} go={setView} />),
    hottakes: (<HotTakes user={user} go={setView} />),
    compare: (<Compare user={user} go={setView} />)
  };

  // Determine theme class based on user gender
  const getThemeClass = () => {
    if (user.gender === 'male') return 'theme-boy';
    if (user.gender === 'female') return 'theme-girl';
    if (user.gender === 'neutral') return 'theme-neutral';
    return '';
  };

  return (
    <div
      key={themeKey} // Force re-render when theme changes
      className={`app-container ${getThemeClass()}`.trim()}
    >
      <nav className="sidebar">
        {navItems.map(([v, icon, label]) =>
          <button
            key={v}
            className={view === v ? 'active' : ''}
            onClick={() => setView(v)}
          >
            <span className="nav-icon">{icon}</span>
            <span className="nav-label">{label}</span>
          </button>
        )}
      </nav>
      <main className="main-content">{views[view]}</main>
      <p className="about-link">
        <a href="/about/">About this project</a>
      </p>
    </div>
  );
}
